<app-page-header>
  <div>Projektübersicht</div>

<!--  <div class="rounded-lg flex flex-row justify-end items-center gap-2 h-10">-->

<!--    <bic-button [routerLink]="['/projects/create']" buttonType="white" class="mr-2 h-10 inline-flex">-->
<!--      Projekt-->
<!--      <fa-icon [icon]="faPlus" iconLeft></fa-icon>-->
<!--    </bic-button>-->
<!--    <div class="rounded-lg flex flex-row justify-end items-center ml-auto h-full border border-gray-300">-->

<!--      &lt;!&ndash; Grid View Button &ndash;&gt;-->
<!--      <button tooltip="Kachelansicht" (click)="setCardView()" class="flex flex-row p-2 rounded-l">-->
<!--        <div class="flex h-5 w-5 justify-center items-center">-->
<!--          <fa-icon [icon]="faGrid2" [ngClass]="isCardView ? 'text-gray' : 'text-gray-300'"></fa-icon>-->
<!--        </div>-->
<!--      </button>-->

<!--      <div class="border-l-2 border-gray-300 h-6"></div>-->

<!--      <button tooltip="Listenansicht" (click)="setListView()" class="flex flex-row p-2 rounded-l">-->
<!--        <div class="flex h-5 w-5 justify-center items-center">-->
<!--          <fa-icon [icon]="faBars" [ngClass]="isListView ? 'text-gray' : 'text-gray-300'"></fa-icon>-->
<!--        </div>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->

<!--        [iconStart]="faMagnifyingGlass"-->

  <div class="flex flex-row items-center gap-4">
    <div class="w-[400px]">
      <bic-input
        [showX]="true"
        [maxLength]="64"
        [iconStart]="faMagnifyingGlass"
        placeholder="Suchen nach..."
        (valueChange)="onSearchTermChange($event)"
      >
      </bic-input>
    </div>
    @if (canCreateProject) {
      <bic-button [routerLink]="['/projects/create']" buttonType="white">Projekt
        <fa-icon [icon]="faPlus" iconLeft></fa-icon>
      </bic-button>
    } @else {
      <div [tooltip]="hasProjectContext ? 'Keine Berechtigung' : 'Bitte wählen Sie zuerst eine Organisation aus.'" [tooltipDirection]="'bottom'" class="cursor-not-allowed">
        <bic-button [disabled]="true" buttonType="white">Projekt
          <fa-icon [icon]="faPlus" iconLeft></fa-icon>
        </bic-button>
      </div>
    }
  </div>
</app-page-header>


@if (loading) {
  <div class="flex flex-col justify-start items-start w-full h-full gap-2 overflow-y-auto">
    <div class="flex flex-col justify-start items-start p-2 w-full pb-20">
      <div class="grid grid-flow-row gap-6 w-full h-full p-2"
           style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
        @for (skeleton of [1, 2, 3, 4]; track skeleton) {
          <div class="flex flex-col gap-4 p-4 border border-gray-200 rounded-lg animate-pulse">
            <div class="flex flex-row items-center justify-between">
              <div class="h-5 bg-gray-200 rounded-full w-40"></div>
              <div class="h-5 bg-gray-200 rounded-full w-5"></div>
            </div>
            <div class="flex flex-col gap-4">
              <div class="flex flex-row gap-4 items-center">
                <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
                <div class="h-5 bg-gray-200 rounded-full flex-1"></div>
                <div class="h-5 bg-gray-200 rounded-full w-16"></div>
              </div>
              <div class="flex flex-row gap-4 items-center">
                <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
                <div class="h-5 bg-gray-200 rounded-full flex-1"></div>
                <div class="h-5 bg-gray-200 rounded-full w-16"></div>
              </div>
              <div class="flex flex-row gap-4 items-center">
                <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
                <div class="h-5 bg-gray-200 rounded-full flex-1"></div>
                <div class="h-5 bg-gray-200 rounded-full w-16"></div>
              </div>
              <div class="flex flex-row gap-4 items-center">
                <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
                <div class="h-5 bg-gray-200 rounded-full w-32"></div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="flex flex-row w-full justify-center items-center gap-2 pt-8">
        <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
        <span class="text-sm font-medium text-gray-500">Projekte werden geladen...</span>
      </div>
    </div>
  </div>
}

@if (!loading && projects && projects.length > 0) {
  <div class="flex flex-col justify-start items-start w-full h-full gap-2 overflow-y-auto">
    <div class="flex flex-row justify-start items-start flex-wrap w-full h-full p-2">
        <div class="flex flex-col justify-start items-start p-2 w-full pb-20">
          <div class="grid grid-flow-row gap-6 w-full h-full p-2"
               style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
            @for (project of filteredProjects; track project) {
              <bic-card (click)="navigateToProject(project)">
                <div class="flex flex-col gap-4 h-full w-full overflow-hidden">
                  <!-- Project Name and Menu Icon -->
                  <div class="flex flex-row items-center justify-between break-words">
                    <div
                      class="text-base w-full text-gray-900 font-medium overflow-hidden break-words hyphens-auto line-clamp-1">
                      {{ project.name }}
                    </div>
                    <div (click)="$event.stopPropagation()" [bicDropdownTrigger]="dropdownProjects"
                         class="hover:opacity-50 px-2 text-base text-gray-900 font-medium">
                      <fa-icon [icon]="faEllipsisVertical"></fa-icon>
                    </div>
                    <bic-dropdown #dropdownProjects [dropdownPlacement]="'bottom-end'">
                      <bic-dropdown-element (click)="$event.stopPropagation()" (onClick)="navigateToProjectSettings(project)">
                        <div class="flex flex-row text-sm gap-3 text-gray-700">
                          <span>Einstellungen</span>
                        </div>
                      </bic-dropdown-element>
                      @if (canLeaveProject(project)) {
                        <bic-dropdown-element (click)="$event.stopPropagation()" (onClick)="openLeaveProject(project)">
                          <div class="flex flex-row text-sm gap-3 text-red-500">
                            <span>Verlassen</span>
                          </div>
                        </bic-dropdown-element>
                      }
                      @if (getIsAdmin(project)) {
                        <bic-dropdown-element (click)="$event.stopPropagation()" (onClick)="openDeleteProject(project)">
                          <div class="flex flex-row text-sm gap-3 text-red-500">
                            <span>Löschen</span>
                          </div>
                        </bic-dropdown-element>
                      }
                    </bic-dropdown>
                  </div>
                  <!-- Project Information -->
                  <div class="flex flex-col justify-center items-start gap-4">
                    <div class="flex flex-row gap-4 w-full items-center">
                      <div class="flex flex-row w-6 shrink-0 justify-center items-center">
                        <fa-icon [icon]="faFolderOpen" class="text-base text-gray-900 font-medium"></fa-icon>
                      </div>
                      <div class="w-full text-gray-900 text-base font-medium">Dateien</div>
                      <div class="flex flex-row text-gray-500 shrink-0 text-base gap-2 items-center px-2">
                        <!--                  {{ project.numberOfFiles }} - -->
                        {{
                          (calculateSizeInGB(project.fileSize!) < 1) ?
                            (calculateSizeInMB(project.fileSize!) | number: '.0-2' : 'de-DE') + ' MB' :
                            (calculateSizeInGB(project.fileSize!) | number: '.0-2' : 'de-DE') + ' GB'
                        }}
                      </div>
                    </div>
                    <div class="flex flex-row gap-4 w-full items-center">
                      <div class="flex flex-row w-6 shrink-0 justify-center items-center">
                        <fa-icon [icon]="faUserGroup" class="text-base text-gray-900 font-medium"></fa-icon>
                      </div>
                      <div class="w-full text-gray-900 text-base font-medium">Personen</div>
                      <div class="text-gray-500 text-base shrink-0 px-2">{{ project.users?.length ?? 0 }}</div>
                    </div>
                    <div class="flex flex-row gap-4 w-full items-center">
                      <div class="flex flex-row w-6 shrink-0 justify-center items-center">
                        <fa-icon [icon]="faBadgeCheck" class="text-base text-gray-900 font-medium"></fa-icon>
                      </div>
                      <div class="w-full text-gray-900 text-base font-medium">Prüfungen</div>
                      <div class="text-gray-500 text-base shrink-0 px-2">{{ project.checksAmount }}</div>
                    </div>
                    <div class="flex flex-row gap-4 justify-start items-center">
                      <ng-container>
                        @if (project.ownerProfilImage) {
                          <img (error)="project.ownerProfilImage = undefined" alt="Verantwortlich" class="w-6 h-6 rounded-full"
                               src="{{project.ownerProfilImage}}">
                        }
                        @if (!project.ownerProfilImage) {
                          <div
                            class="relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-gray-100 rounded-full">
                            @if (project.owner) {
                            @if (project.owner.split(' ').length == 1) {
                              <span
                                class="font-medium text-gray-900 text-base">{{ project.owner!.split(' ')[0].charAt(0).toUpperCase() }}</span>
                            }
                            @if (project.owner.split(' ').length > 1) {
                              <span
                                class="font-medium text-gray-900 text-base">{{ project.owner!.split(' ')[0].charAt(0).toUpperCase() }}{{ project.owner.split(' ')[1].charAt(0).toUpperCase() }}</span>
                            }
                            }
                          </div>
                        }
                        <div class="flex flex-col">
                          <span class="text-base text-gray-900 font-medium w-full overflow-hidden break-words hyphens-auto line-clamp-1">
                            {{ project.owner }}
                          </span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </bic-card>
            }
          </div>
        </div>
    </div>
</div>
}

@if (!loading && dataSource && dataSource.data.length == 0) {
  @if (!hasProjectContext) {
    <app-empty-state [icon]="faDiagramProject"
                     message="Bitte wählen Sie zuerst eine Organisation aus, um Projekte zu sehen."></app-empty-state>
  } @else {
    <app-empty-state [icon]="faDiagramProject" message="Erstellen Sie Ihr erstes Projekt, um loszulegen.">
      @if (canCreateProject) {
        <bic-button [routerLink]="['/projects/create']" buttonType="white">Projekt erstellen
          <fa-icon [icon]="faPlus" iconLeft></fa-icon>
        </bic-button>
      } @else {
        <div [tooltip]="'Keine Berechtigung'" class="cursor-not-allowed">
          <bic-button [disabled]="true">Projekt erstellen
            <fa-icon [icon]="faPlus" iconLeft></fa-icon>
          </bic-button>
        </div>
      }
    </app-empty-state>
  }
}

<!--@if (leaveProjectBoolean) {-->
<!--  <app-pop-up-->
<!--            [message]="'<strong>Möchten Sie das Projekt “<em>'+ selectedProject.name +'</em>” wirklich verlassen?</strong><br> <br>'+-->
<!--            'Bei Bestätigung verlieren Sie mit sofortiger Wirkung den Zugriff auf <strong>sämtliche Projektdaten, Prüfergebnisse, die Projektverwaltung</strong> und Mitglieder.<br> <br>'" [approveButtonName]="'Bestätigen'"-->
<!--            (approvedPressed)="leaveProject(selectedProject)"-->
<!--            (declinedPressed)="leaveProjectBoolean=false">-->
<!--  </app-pop-up>-->
<!--}-->

@if (leaveProjectBoolean) {
  <bic-popup (close)="leaveProjectBoolean=false" [hasBackdrop]="true" [title]="'Möchten Sie das Projekt '+ '“' +selectedProject.name + '”' +' wirklich verlassen?'" customClass="w-[560px] h-fit">
    <div bicPopupContent class="flex flex-col">
      <span class="font-normal">Bei Bestätigung verlieren Sie mit sofortiger Wirkung den Zugriff auf sämtliche Projektdaten, Prüfergebnisse, die Projektverwaltung und Mitglieder.</span>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
      <bic-button (onClick)="leaveProjectBoolean=false" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="leaveProject(selectedProject)" buttonType="red">Verlassen</bic-button>
    </div>
  </bic-popup>
}

<!--@if (deleteProjectBoolean) {-->
<!--  <app-pop-up-->
<!--            [message]="'<strong>Möchten Sie das Projekt “<em>'+ selectedProject.name +'</em>” wirklich löschen?</strong><br> <br>' +-->
<!--   'Bei Bestätigung wird das Projekt “Beispielprojekt” unwiderruflich gelöscht. <strong>Alle Mitglieder</strong> verlieren mit sofortiger Wirkung den Zugriff auf Projektdaten, Prüfergebnisse und die Projektverwaltung.<br> <br>'"-->
<!--            [approveButtonName]="'Bestätigen'" (approvedPressed)="deleteProject(selectedProject)"-->
<!--            (declinedPressed)="deleteProjectBoolean = false"></app-pop-up>-->
<!--}-->
@if (deleteProjectBoolean) {
  <bic-popup (close)="deleteProjectBoolean = false" [hasBackdrop]="true" [title]="'Möchten Sie das Projekt '+ '“' +selectedProject.name + '”' +' wirklich löschen?'" customClass="w-[560px] h-fit">
    <div bicPopupContent class="flex flex-col">
      <span class="font-normal">Bei Bestätigung wird das Projekt “{{ selectedProject.name }}” unwiderruflich gelöscht. Alle Mitglieder verlieren mit sofortiger Wirkung den Zugriff auf Projektdaten, Prüfergebnisse und die Projektverwaltung. </span>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
      <bic-button (onClick)="deleteProjectBoolean = false" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="deleteProject(selectedProject)" buttonType="red">Löschen</bic-button>
    </div>
  </bic-popup>
}
<!--@if (deleteAndLeaveProjectBoolean) {-->
<!--  <app-pop-up-->
<!--            [message]="'<strong>Möchten Sie das Projekt “<em>'+ selectedProject.name +'</em>” wirklich löschen?</strong><br> <br>' +-->
<!--   'Bei Bestätigung wird das Projekt “Beispielprojekt” unwiderruflich gelöscht. <strong>Alle Mitglieder</strong> verlieren mit sofortiger Wirkung den Zugriff auf Projektdaten, Prüfergebnisse und die Projektverwaltung.<br> <br>'"-->
<!--            [approveButtonName]="'Bestätigen'" (approvedPressed)="deleteProject(selectedProject)"-->
<!--            (declinedPressed)="deleteAndLeaveProjectBoolean = false"></app-pop-up>-->
<!--}-->
